module.exports = __webpack_public_path__ + "static/media/ffsp-logo_light.cd4eabdf.png";